import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Afterloginheader from "../../components/MainHeader/Afterloginheader";
import Sidebar from "../../components/Sidebar";
import {
  addPatientMemberApi, createTimelineObservation,
  createAppointmentApi,
  createAppointmentByDoctorApi,
  dateAvailabilityApi,
  getAppointmentBookingStep1,
  getQuestionApi,
} from "../../services/apiService";
import Skeleton from "react-loading-skeleton";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format } from "date-fns";
import { useUserContext } from "../../context/UserContext";

import docimg from "../../assets/images/DocImg.png";
import CrossIcon from "../../assets/images/CrossIcon.svg";
import StarIcon from "../../assets/images/StarIcon.svg";
import VideoIcon from "../../assets/images/VideoIcon.svg";
import CabinetIcon from "../../assets/images/CabinetIcon.svg";
import UserIcon from "../../assets/images/User_Icon.svg";
import CalanderIcon from "../../assets/images/CalanderIcon.svg";
import LocIcon from "../../assets/images/LocationIcon.svg";
import StethIcon from "../../assets/images/StethoscopeIcon.svg";
import NoImage from "../../assets/images/no-image-avatar.png";
import { IMAGE_URL } from "../../app_url";
import moment from "moment";
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import LoadingPage from "../../components/LoadingPage";
import { useGetQuesions, useGetAppointmentBookingStep1, useCreateAppointmentByDoctor } from "../../queries";

import { useBroadcastListener } from '@/services/broadcast/broadcastService';


import { APPOINTMENT_BROADCAST_KEYS } from "@/services/broadcast/broadcastKeys";

Modal.setAppElement("#root");

const BookAppointmentByDoctor = () => {
  const { userData, searchValuesContext } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedStep, setSelectedStep] = useState(1);
  const [choosePatient, setChoosePatient] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [alreadyVisit, setAlreadyVisit] = useState("yes");
  const [patientForm, setPatientForm] = useState({ name: "", age: "", relation: "" });
  const [addBtnDis, setAddBtnDis] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [chooseReason, setChooseReason] = useState("");
  const [consultType, setConsultType] = useState("");
  const [doctorSavedCunsultType, setDoctorSavedCunsultType] = useState("0");
  const [date, setDate] = useState(new Date());
  const [availDates, setAvailDates] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [appTimeDateAlreadySelected, setAppTimeDateAlreadySelected] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [futureDate, setFutureDate] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [bookAppByDocObj, setBookAppByDocObj] = useState();

  const { mutateAsync: createAppointmentAsync } = useCreateAppointmentByDoctor();



  useEffect(() => {
    setDoctorSavedCunsultType(userData?.users?.consultation_type || "0");
  }, []);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleConsultTypeChange = event => {
    setConsultType(event.target.value);
  };


  /**
   * register Broadcasting Handlers
   */


  const handleChooseResCont = () => {
    if (!chooseReason) {
      toast.warning("Please choose a reason to continue.", { autoClose: 1500 });
    } else {
      setSelectedStep(4);
    }
  };

  const handleChooseConsultCont = async () => {
    if (!consultType) {
      toast.warning("Please choose a consultation type to continue.", { autoClose: 1500 });
    } else {
      if (appTimeDateAlreadySelected) {
        setSelectedStep(questionDetails?.length + 3);
      } else {
        setSelectedStep(questionDetails?.length + 2);
      }

      let tempconsultType = consultType === "Video" ? "For online consultation" : consultType === "Cabinet" ? "For cabinet consultation " : "";
      getDateAvailabilityList(searchValuesContext?.user_id, format(date, "yyyy-MM-dd"), tempconsultType);
    }
  };

  const handleChooseTimeCont = async () => {
    if (!selectedTime) {
      toast.warning("Please choose a timing for your appointment.", { autoClose: 1500 });
    } else {
      setSelectedStep(questionDetails?.length + 3);
    }
  };

  const handleDateChange = newDate => {
    setDate(newDate);
    // setSelectedStep(5);
    let tempconsultType = consultType === "Video" ? "For online consultation" : consultType === "Cabinet" ? "For cabinet consultation " : "";
    setSelectedTime(null);
    getDateAvailabilityList(searchValuesContext?.user_id, format(newDate, "yyyy-MM-dd"), tempconsultType);
  };

  const {
    data: allDetails,
    isLoading: isLoadingAppointmentBookingsStep1,
    refetch: refetchAppointmentBookingsStep1
  } = useGetAppointmentBookingStep1({
    doctor_id: userData?.users?.id
  })


  // TODO organize this later

  const {
    data: questionDetails,
    isLoading: isLoadingQuerstions,
    refetch: refetchQuesions,
  } = useGetQuesions({
    doctor_id: userData?.users?.id
  })

  const getDateAvailabilityList = async (docId, date, consultationType) => {
    if (docId && date && consultationType) {
      setScreenLoading(true);
      try {
        let formData = new FormData();
        formData.append("doctor_id", docId);
        formData.append("date", date);
        formData.append("consultation_types", consultationType);

        let response = await dateAvailabilityApi(formData);
        if (response) {
          if (response.data.res === true) {
            // const notAvailableSet = new Set(response.data.notAvailable.map(({time}) => time));
            // const tempArray = response.data.data.filter(item => !notAvailableSet.has(item));
            const tempFormatHoliday = response.data.holiday ? response.data.holiday.map(item => item.holiday_date) : [];
            if (tempFormatHoliday.includes(date)) {
              setAvailDates([]);
            } else {
              setAvailDates(response.data.data);
            }
            setBookedAppoinment(response.data.notAvailable.map(({ time }) => time));

            const tempFutureDate = moment().add(parseInt(response.data.future_days, 10), "days");
            setFutureDate(tempFutureDate);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setScreenLoading(false);
      } catch (error) {
        setScreenLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const handleSelectTime = time => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach(element => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning("Oops! This time slot is full. Please try on different time.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(title);
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning("Oops! This time slot is already taken. Please choose a different slot.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(time);
      }
    }
  };

  console.log('de', doctorSavedCunsultType)


  const handleConfirmAppointment = async () => {
    if (!bookAppByDocObj) {
      return toast.error("Something went wrong. Please try again.", { autoClose: 1500 });
    }

    setAddBtnDis(true);
    try {
      let formData = new FormData();

      // ===== Données patient =====
      if (bookAppByDocObj?.oldPatientDetails?.id) {
        formData.append("patient_id", bookAppByDocObj.oldPatientDetails.id);
      } else {
        formData.append("first_name", bookAppByDocObj?.patientFirstName || "");
        formData.append("last_name", bookAppByDocObj?.patientLastName || "");
        formData.append("cell_phone", bookAppByDocObj?.patientNumber || "");
        formData.append("gender", bookAppByDocObj?.patientGender || "");
        formData.append("city_id", bookAppByDocObj?.patientCity || "");
        formData.append("birth_city_id", bookAppByDocObj?.birthCity || "");
        formData.append("municipality_id", bookAppByDocObj?.municipality_id || "");
        formData.append("id_number", bookAppByDocObj?.idNumber || "");
        formData.append("year", bookAppByDocObj?.patientYear || "");
        formData.append("month", bookAppByDocObj?.patientMonth || "");
        formData.append("day", bookAppByDocObj?.patientDay || "");
        formData.append("appointment_type", bookAppByDocObj?.appointmentType || "");
        formData.append("patient_id", bookAppByDocObj?.patientId || "");
      }

      // ===== Données rendez-vous =====
      formData.append("appointment_id", bookAppByDocObj?.appointmentId || "");
      formData.append("appointment_date", format(bookAppByDocObj?.date, "yyyy-MM-dd") || "");
      formData.append("time", bookAppByDocObj?.appTime || "");
      formData.append(
        "consultation_type",
        consultType === "Video"
          ? "For online consultation"
          : consultType === "Cabinet"
            ? "For cabinet consultation"
            : ""
      );

      // ===== Réponses aux questions =====
      answers.forEach((item, index) => {
        if (item.skipped !== 1) {
          formData.append(`options[${index}][question_id]`, item?.questId);
          formData.append(`options[${index}][options_id]`, item?.optionId);
          formData.append(`options[${index}][options_value]`, item?.value);
        }
      });

      // ===== Appel API pour créer le rendez-vous =====
      const response = await createAppointmentAsync(formData);

      console.log("book appointment", response)

      if (response?.data?.res === true) {
        const appointmentId = response.data.data;
        const patient_id = response.data.patient_id
        console.log("patient_id", patient_id)

        // ===== Récupération sécurisée du doctorId =====
        const doctorId = bookAppByDocObj?.doctorId || userData?.users?.id;
        if (doctorId) {
          try {
            await createTimelineObservation(doctorId, {
              patient_id: patient_id,
              titre: "consultation",
              type: "card",
              date: format(new Date(), "yyyy-MM-dd"),
            });
          } catch (timelineError) {
            console.error("Erreur lors de l'ajout de la timeline:", timelineError);
            toast.error("Appointment booked, but failed to add timeline card.", { autoClose: 2000 });
          }
        } else {
          console.warn("Impossible d'ajouter la timeline: doctorId manquant");
          toast.warning("Timeline card not added: doctor ID missing", { autoClose: 2000 });
        }

        // ===== Navigation après succès =====
        if (bookAppByDocObj?.isUnschedule || bookAppByDocObj?.appointmentType === "without-tracking") {
          navigate(`/doctor/appointment-details/${appointmentId}`);
        } else {
          navigate("/doctor/appointments");
        }

        // ===== Nettoyage =====
        sessionStorage.removeItem("doctolikAddAppObjByDoc");
        toast.success(response.data.msg || "Appointment booked successfully.", { autoClose: 1500 });
      } else {
        toast.error(response.data.msg, { autoClose: 1500 });
      }

      setAddBtnDis(false);
    } catch (error) {
      setAddBtnDis(false);
      console.error(error);
      // Don't show generic error if it's a subscription expired 403 error (interceptor already shows toast)
      if (error.response?.status !== 403) {
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };


  const handleOptionChange = (stepIndex, question, questId, value, optionId) => {
    if (stepIndex && questId && value && optionId) {
      let newAnswers = [...answers];
      const existingIndex = newAnswers.findIndex(answer => answer?.questId === questId);
      const newAnswer = { questId, question, value, optionId, skipped: 0 };

      if (existingIndex !== -1) {
        // If the questId already exists, update the existing answer
        newAnswers[existingIndex] = newAnswer;
      } else {
        // Otherwise, add the new answer
        newAnswers[stepIndex] = newAnswer;
      }

      const filteredAnswers = newAnswers.filter(answer => answer !== undefined && Object.keys(answer).length > 0);
      setAnswers(filteredAnswers);
    }
  };

  const canContinue = () => {
    return answers[selectedStep - 1] !== undefined && answers[selectedStep - 1] !== null;
  };

  const renderStepContent = stepIndex => {
    const currentQuestion = questionDetails[stepIndex - 1];
    return (
      <div className="ContainerPnl ContainerPnl1">
        <div className="ColPnl-8">
          <div className="LftBox">
            {stepIndex > 0 && (
              <button
                className="PrevBtn"
                onClick={() => {
                  if (stepIndex === 1) {
                    if (location?.state?.fromUrl) {
                      navigate(location?.state?.fromUrl);
                    } else {
                      navigate(`/doctor/appointments`);
                    }
                  } else {
                    setSelectedStep(stepIndex - 1);
                  }
                }}>
                Go to back previous step
              </button>
            )}
            <h2>{currentQuestion?.question}</h2>
            <ul className="PatientList AlreadyVisit">
              {currentQuestion?.options.map(option => (
                <li key={option.id} onClick={() => handleOptionChange(stepIndex, currentQuestion?.question, currentQuestion?.id, option.options, option?.id)}>
                  <span className="PatientName">
                    <span className="NameWrapper">{option.options}</span>
                  </span>
                  <span className="SelectOption">
                    <input type="radio" value={option.options.toLowerCase()} checked={answers[stepIndex - 1]?.value === option.options} onChange={() => { }} />
                  </span>
                </li>
              ))}
            </ul>
            {questionDetails[0]?.no === 1 && answers.find(item => item?.questId === questionDetails[0]?.id)?.value === "No" ? (
              <button
                className="CmnBtn"
                onClick={() => toast.warning("Sorry! You can't book an appointment with this doctor right now. Please check back later.", { autoClose: 1500 })}>
                Continue
              </button>
            ) : (
              <p>
                <button
                  className="CmnBtn"
                  onClick={() => {
                    if (canContinue()) {
                      let tempAnsw = [...answers];
                      tempAnsw[stepIndex - 1].skipped = 0;
                      setAnswers(tempAnsw);

                      setSelectedStep(stepIndex + 1);
                      if (doctorSavedCunsultType === "1") {
                        //setSelectedStep(stepIndex + 1);
                      } else {
                        //setSelectedStep(stepIndex + 2);
                        setConsultType("Cabinet");
                      }
                    } else {
                      toast.warning("Please select an option before continuing.", { autoClose: 1500 });
                    }
                  }}>
                  Continue
                </button>
                {currentQuestion?.ask === 0 ? (
                  <button
                    className="CmnBtn skipBtn"
                    onClick={() => {
                      let tempAnsw = [...answers];
                      if (tempAnsw[stepIndex - 1]) {
                        tempAnsw[stepIndex - 1].skipped = 1;
                        setAnswers(tempAnsw);
                      }
                      setSelectedStep(stepIndex + 1);
                      setChooseReason(null);
                    }}>
                    Skip
                  </button>
                ) : null}
              </p>
            )}
          </div>
        </div>
        <div className="ColPnl-4">
          <div className="RhtBox">
            <ul className="SearchedDoctors">
              <li>
                <div className="DocDtls">
                  <span className="DocName">
                    {bookAppByDocObj?.oldPatientDetails
                      ? `${bookAppByDocObj?.oldPatientDetails?.first_name} ${bookAppByDocObj?.oldPatientDetails?.last_name}`
                      : `${bookAppByDocObj?.patientFirstName} ${bookAppByDocObj?.patientLastName}`}
                  </span>
                  {bookAppByDocObj?.oldPatientDetails?.gender || bookAppByDocObj?.patientGender ? (
                    <span>
                      Gender: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.gender}` : `${bookAppByDocObj?.patientGender}`}
                    </span>
                  ) : null}
                  {/* <span>Age: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.age}` : `${bookAppByDocObj?.patientAge}`}</span> */}
                  {/* <span>
                    Address: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.city_name}` : `${bookAppByDocObj?.patientAddress}`}
                  </span> */}
                  {bookAppByDocObj?.oldPatientDetails?.cell_phone || bookAppByDocObj?.patientNumber ? (
                    <span>
                      Phone: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.cell_phone}` : `${bookAppByDocObj?.patientNumber}`}
                    </span>
                  ) : null}
                </div>
              </li>
            </ul>
            <div className="AppoDetails">
              <h5>Your appointment in detail</h5>
              <ul>
                {bookAppByDocObj && (
                  <li>
                    {format(bookAppByDocObj?.date, "MMMM d")} {bookAppByDocObj?.appTime}
                  </li>
                )}
                {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  useEffect(() => {
    let value = sessionStorage.getItem("doctolikAddAppObjByDoc");
    console.log(value);
    if (value) {
      let parsedVal = JSON.parse(value);
      setBookAppByDocObj(parsedVal);
    } else {
      navigate(`/doctor/dashboard`);
    }
  }, []);

  return (
    <div className="doctormain">
      <Sidebar />
      <div className="rightSec">
        <DashboardDoctorHeader />

        <div className="mainDiv">
          {screenLoading && <LoadingPage />}
          <div className="BookAppWrapper">
            <div className="HeadingBar">
              <div className="ContainerPnl ContainerPnl1">
                <div className="ColPnl-12">
                  <h3>Book your appointment</h3>
                  <p>Fill in the following information</p>
                </div>
              </div>
            </div>

            {selectedStep > 0 && selectedStep < questionDetails?.length + 1 && renderStepContent(selectedStep)}

            {!screenLoading && selectedStep === questionDetails?.length + 1 ? (
              <div className="ContainerPnl ContainerPnl1">
                <div className="ColPnl-8">
                  <div className="LftBox">
                    <button className="PrevBtn" onClick={() => setSelectedStep(questionDetails?.length)}>
                      Go to back previous step
                    </button>
                    <h2>Did you want to consultation via video or cabinet?</h2>
                    <ul className="PatientList ConsultOption">
                      {doctorSavedCunsultType == 1 || doctorSavedCunsultType == 0 ? (
                        <li onClick={() => setConsultType("Video")}>
                          <span className="PatientName">
                            <img src={VideoIcon} alt="" />
                            <span className="NameWrapper">Video consultation</span>
                          </span>
                          <span className="SelectOption">
                            <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                          </span>
                        </li>
                      ) : null}

                      {doctorSavedCunsultType == 2 || doctorSavedCunsultType == 0 ? (
                        <li onClick={() => setConsultType("Cabinet")}>
                          <span className="PatientName">
                            <img src={CabinetIcon} alt="" />
                            <span className="NameWrapper">Cabinet consultation</span>
                          </span>
                          <span className="SelectOption">
                            <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                          </span>
                        </li>
                      ) : null}
                      {/* {doctorSavedCunsultType === "0" ? (
                        <>
                          <li onClick={() => setConsultType("Video")}>
                            <span className="PatientName">
                              <img src={VideoIcon} alt="" />
                              <span className="NameWrapper">Video consultation</span>
                            </span>
                            <span className="SelectOption">
                              <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                            </span>
                          </li>
                          <li onClick={() => setConsultType("Cabinet")}>
                            <span className="PatientName">
                              <img src={CabinetIcon} alt="" />
                              <span className="NameWrapper">Cabinet consultation</span>
                            </span>
                            <span className="SelectOption">
                              <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                            </span>
                          </li>
                        </>
                      ) : doctorSavedCunsultType === "1" ? (
                        <>
                          <li onClick={() => setConsultType("Video")}>
                            <span className="PatientName">
                              <img src={VideoIcon} alt="" />
                              <span className="NameWrapper">Video consultation</span>
                            </span>
                            <span className="SelectOption">
                              <input type="radio" value="Video" checked={consultType === "Video"} onChange={handleConsultTypeChange} />
                            </span>
                          </li>
                        </>
                      ) : doctorSavedCunsultType === "2" ? (
                        <>
                          <li onClick={() => setConsultType("Cabinet")}>
                            <span className="PatientName">
                              <img src={CabinetIcon} alt="" />
                              <span className="NameWrapper">Cabinet consultation</span>
                            </span>
                            <span className="SelectOption">
                              <input type="radio" value="Cabinet" checked={consultType === "Cabinet"} onChange={handleConsultTypeChange} />
                            </span>
                          </li>
                        </>
                      ) : null} */}
                    </ul>
                    <p>
                      <button className="CmnBtn" onClick={() => handleChooseConsultCont()}>
                        Continue
                      </button>
                    </p>
                  </div>
                </div>
                <div className="ColPnl-4">
                  <div className="RhtBox">
                    <ul className="SearchedDoctors">
                      <li>
                        <div className="DocDtls">
                          <span className="DocName">
                            {bookAppByDocObj?.oldPatientDetails
                              ? `${bookAppByDocObj?.oldPatientDetails?.first_name} ${bookAppByDocObj?.oldPatientDetails?.last_name}`
                              : `${bookAppByDocObj?.patientFirstName} ${bookAppByDocObj?.patientLastName}`}
                          </span>
                          {bookAppByDocObj?.oldPatientDetails?.gender || bookAppByDocObj?.patientGender ? (
                            <span>
                              Gender:{" "}
                              {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.gender}` : `${bookAppByDocObj?.patientGender}`}
                            </span>
                          ) : null}
                          {/* <span>
                            Age: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.age}` : `${bookAppByDocObj?.patientAge}`}
                          </span>
                          <span>
                            Address:{" "}
                            {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.city_name}` : `${bookAppByDocObj?.patientAddress}`}
                          </span> */}
                          {bookAppByDocObj?.oldPatientDetails?.cell_phone || bookAppByDocObj?.patientNumber ? (
                            <span>
                              Phone:{" "}
                              {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.cell_phone}` : `${bookAppByDocObj?.patientNumber}`}
                            </span>
                          ) : null}
                        </div>
                      </li>
                    </ul>
                    <div className="AppoDetails">
                      <h5>Your appointment in detail</h5>
                      <ul>
                        {bookAppByDocObj && (
                          <li>
                            {format(bookAppByDocObj?.date, "MMMM d")} {bookAppByDocObj?.appTime}
                          </li>
                        )}
                        {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
                        {/* <li>Did you already visit this doctor?</li>
                    {chooseReason ? <li>What is the reason of the consultation?</li> : null} */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {selectedStep === questionDetails?.length + 2 ? (
              <div className="ContainerPnl ContainerPnl1">
                <div className="ColPnl-8">
                  <div className="LftBox">
                    <button
                      className="PrevBtn"
                      onClick={() => {
                        if (doctorSavedCunsultType === "1") {
                          setSelectedStep(questionDetails?.length + 1);
                        } else {
                          setSelectedStep(questionDetails?.length);
                        }
                      }}>
                      Go to back previous step
                    </button>
                    <h2>Your appointment in detail</h2>
                    <ul className="PatientList ConsultOption BookingDetails">
                      <li>
                        <span className="PatientName">
                          {/* <img className="profilePic" src={allDetails?.doctor?.profile_pic ? IMAGE_URL + allDetails?.doctor?.profile_pic : NoImage} alt="" /> */}
                          <span className="NameWrapper">
                            {bookAppByDocObj?.oldPatientDetails
                              ? `${bookAppByDocObj?.oldPatientDetails?.first_name} ${bookAppByDocObj?.oldPatientDetails?.last_name}`
                              : `${bookAppByDocObj?.patientFirstName} ${bookAppByDocObj?.patientLastName}`}
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="PatientName">
                          <img src={CalanderIcon} alt="" />
                          <span className="NameWrapper">
                            {format(bookAppByDocObj?.date, "MMMM d")} {bookAppByDocObj?.appTime}
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="PatientName">
                          <img src={LocIcon} alt="" />
                          <span className="NameWrapper">{allDetails?.doctor?.cabin_address}</span>
                        </span>
                      </li>
                      <li>
                        <span className="PatientName">
                          <img src={StethIcon} alt="" />
                          <span className="NameWrapper">{allDetails?.doctor?.speciality}</span>
                        </span>
                      </li>
                    </ul>
                    <p>
                      <button className="CmnBtn FullwidthBtn" onClick={() => handleConfirmAppointment()} disabled={addBtnDis}>
                        {addBtnDis ? "Please wait..." : "Confirm appointment"}
                      </button>
                    </p>
                    <p className="NotePara">By confirming this appointment, you agree to honour it.</p>
                  </div>
                </div>
                <div className="ColPnl-4">
                  <div className="RhtBox">
                    <ul className="SearchedDoctors">
                      <li>
                        <div className="DocDtls">
                          <span className="DocName">
                            {bookAppByDocObj?.oldPatientDetails
                              ? `${bookAppByDocObj?.oldPatientDetails?.first_name} ${bookAppByDocObj?.oldPatientDetails?.last_name}`
                              : `${bookAppByDocObj?.patientFirstName} ${bookAppByDocObj?.patientLastName}`}
                          </span>
                          {bookAppByDocObj?.oldPatientDetails?.gender || bookAppByDocObj?.patientGender ? (
                            <span>
                              Gender:{" "}
                              {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.gender}` : `${bookAppByDocObj?.patientGender}`}
                            </span>
                          ) : null}
                          {/* <span>
                            Age: {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.age}` : `${bookAppByDocObj?.patientAge}`}
                          </span>
                          <span>
                            Address:{" "}
                            {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.city_name}` : `${bookAppByDocObj?.patientAddress}`}
                          </span> */}
                          {bookAppByDocObj?.oldPatientDetails?.cell_phone || bookAppByDocObj?.patientNumber ? (
                            <span>
                              Phone:{" "}
                              {bookAppByDocObj?.oldPatientDetails ? `${bookAppByDocObj?.oldPatientDetails?.cell_phone}` : `${bookAppByDocObj?.patientNumber}`}
                            </span>
                          ) : null}
                        </div>
                      </li>
                    </ul>
                    <div className="AppoDetails">
                      <h5>Your appointment in detail</h5>
                      <ul>
                        {/* <li>Did you already visit this doctor?</li> */}
                        {bookAppByDocObj && (
                          <li>
                            {format(bookAppByDocObj?.date, "MMMM d")} {bookAppByDocObj?.appTime}
                          </li>
                        )}
                        {answers?.map((item, index) => (item?.skipped !== 1 ? <li key={index}>{item?.question}?</li> : null))}
                        {/* {chooseReason ? <li>What is the reason of the consultation?</li> : null} */}
                        <li>Did you want to consultation via video or cabinet?</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {/* Add new member popup */}
          <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="">
            <img className="CloseModalBtn" src={CrossIcon} onClick={closeModal} alt="" />
            <h2>Add new member</h2>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</p>
            <ul className="AddNewMember">
              <li>
                <label>New member name</label>
                <input type="text" placeholder="Type here" value={patientForm.name} onChange={e => setPatientForm(prev => ({ ...prev, name: e.target.value }))} />
              </li>
              <li>
                <label>New member age</label>
                <input type="number" placeholder="Type here" value={patientForm.age} onChange={e => setPatientForm(prev => ({ ...prev, age: e.target.value }))} />
              </li>
              <li>
                <label>Relationship with you</label>
                <input
                  type="text"
                  placeholder="Type here"
                  value={patientForm.relation}
                  onChange={e => setPatientForm(prev => ({ ...prev, relation: e.target.value }))}
                />
              </li>
              <li>
                <button className="CmnBtn" type="button" onClick={handleConfirmAppointment} disabled={addBtnDis}>
                  {addBtnDis ? "Please wait..." : "Add New"}
                </button>
              </li>
            </ul>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default BookAppointmentByDoctor;
